import Axios from 'axios';

const requester = Axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

const token = localStorage.getItem('token');

if (token) {
  requester.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

requester.interceptors.response.use(null, (err) => {
  const responseURL = err.response.config.url;
  if (err.response.status === 401 && responseURL !== '/api/login') {
    localStorage.removeItem('token');
    window.location.reload();
  }
  return Promise.reject(err);
});

export default requester;
